import axios from 'axios';
const apiEndPoint = process.env.REACT_APP_API_URL;



const getListMembers = async () => {
  const response = await axios.get(`${apiEndPoint}/members?_sort=surname:ASC,name:ASC`)
  return response.data;

}

export {getListMembers};